// extracted by mini-css-extract-plugin
export var circle = "_37-2";
export var icon = "_37-a";
export var iconHighlight = "_37-0";
export var lg = "_37-8";
export var md = "_37-7";
export var outline = "_37-4";
export var sm = "_37-6";
export var square = "_37-1";
export var xl = "_37-9";
export var xs = "_37-5";
export var xxs = "_37-3";